/**
 * initJs by container
 *
 * @param container
 */
export function initJs(container) {
    // List table
    let listingForm = container.find('.listing-form');
    if (listingForm.length) {
        listingForm.each(function () {
            let form = $(this);
            let id = form.attr('data-id');

            if (typeof (id) === 'undefined') {
                form.attr('data-id', Listing.guid());
            }

            // Render table
            Listing.tableFilter(form);
        });
    }

    // Select2
    container.find('.select').each(function () {
        let selectOptions = $(this).siblings('#select-options').html(),
            options = selectOptions !== undefined ? selectOptions : '{}';

        $(this).select2($.extend(
            {
                minimumResultsForSearch: 101,
                placeholder: function () {
                    $(this).data('placeholder');
                },
                dropdownAutoWidth: true,
                width: $(this).hasClass('select-auto') ? 'auto' : '100%',
                templateResult: Fnc.formatSelect2TextOption,
                templateSelection: Fnc.formatSelect2TextSelected
            },
            JSON.parse(options)
        ));
    });

    // Default datepicker
    container.find('.datepicker').each(function () {
        let _this = $(this),
            minDate = _this.data('start'),
            maxDate = _this.data('end'),
            viewMode = _this.data('view'),
            viewOptions = _this.siblings('.datepicker-options').html(),
            formats = {
                years: {
                    view: 'years',
                    minView: 'years',
                    dateFormat: 'yyyy'
                },
                months: {
                    view: 'months',
                    minView: 'months',
                    dateFormat: 'yyyy-MM'
                },
                days: {
                    view: 'days',
                    minView: 'days',
                    dateFormat: 'yyyy-MM-dd'
                }
            };

        new AirDatepicker(this, {
            minDate: minDate !== undefined ? minDate.toString() : false,
            maxDate: maxDate !== undefined ? maxDate.toString() : false,
            autoClose: true,
            isMobile: Fnc.isMobileOrTablet(),
            ...formats[viewMode],
            ...(viewOptions !== '{}' && viewOptions !== undefined ? JSON.parse(viewOptions) : false),
        })

        // Overrides datetimepicker value, if maxDate of minDate is specified
        if (minDate !== undefined || maxDate !== undefined) {
            _this.val(_this.attr('value'));
        }
    });

    container.find('.btn-popover').each(function () {
        let _this = $(this),
            trigger = _this.data('bs-trigger');

        let popover = new Bootstrap.Popover(_this, {
            trigger: trigger !== undefined ? trigger : 'focus',
        });
    });

    // Select2 ajax
    container.find('.select2-ajax').each(function () {
        Fnc.select2Ajax($(this));
    });

    // Scrollbar
    container.find('.scrollbar-inner').scrollbar();
}

/**
 * Initialize custom validation function
 */
export function initVCustomValidation() {
    $('body .form-validate-jquery').each(function () {
        Validator.customValidate($(this));
    });
}
